import { useQueryPreferredOrderRequestFlow } from '../../models/useQueryPreferredOrderRequestFlow'

export const useGetPreferredOrderRequestFlowPresenter = (userId: number) => {
  const { preferredOrderRequestFlow, isFetching } =
    useQueryPreferredOrderRequestFlow(userId)

  return {
    data: {
      preferredOrderRequestFlow,
    },
    states: {
      isFetching,
    },
  }
}
